var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3DModelsGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8746 55.5625L14.7266 69.6959L34.5678 81.5508V66.8596L14.8746 55.5625Z",
    fill: "#B4C5D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1462 69.5337L39.9985 83.667L59.839 95.5217V80.8315L40.1462 69.5337Z",
    fill: "#B4C5D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1462 91.5908L39.9985 105.724L59.839 117.207V102.515L40.1462 91.5908Z",
    fill: "#B4C5D0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8746 76.5254L14.7266 90.6588L34.5678 102.514V87.8232L14.8746 76.5254Z",
    fill: "#B4C5D0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1709 14.104L120.853 45.8202V69.7711L140.921 81.6372V105.643L66.1709 62.1698V14.104Z",
    fill: "#CDD9E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140.999 105.748L66.2372 62.2026L53.7173 69.9878",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.974 45.7142L65.9882 14L11.001 45.7661L65.9882 77.3124L120.974 45.7142Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2368 101.553L121.224 69.9551",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.974 69.9153L65.9875 38.2012L32.0488 57.6059",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 93.9678L86.0124 137.345L140.999 105.747",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2368 14.1997V62.2019",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2368 77.3125V101.445",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M120.974 45.7661V69.8981",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M121.224 69.9551L140.999 81.6317",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M140.999 105.747V81.6318",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0049 137.47V113.354",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2368 101.554L86.004 113.354",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141 81.6318L86.0049 113.353",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11 69.3179L11.2498 93.9678",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11 45.7661V69.8981",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DModelsGrey);
export default __webpack_public_path__ + "static/media/3d_models_grey.1a2c68e3d4e3a2c57d3f1ec51396fca5.svg";
export { ForwardRef as ReactComponent };